import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { Typography } from "@mui/material";

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      "#424242",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#007afd",
  },
}));

export default function ChartsLeave(props) {
  const { useLeave, max, leave } = props;
  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <Typography variant="h4" style={{ marginRight: 4 }}>
        {useLeave}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          วัน
        </Typography>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="body1" color="text.secondary" style={{ fontWeight: 500 }}>
          {leave}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {max} วัน
        </Typography>
      </div>
      <BorderLinearProgress variant="determinate" value={50} />
    </div>
  );
}
